<template>
	<div class="order_index">
		<header class="d-flex j-sb a-center">
			<div class="info d-flex flex-column j-sb a-center" style="font-size: 0.75rem;color: #666666;padding: 1.81rem 0;">
				<div class="icon">
				</div>
				<div class="d-flex j-start a-center">
					<span style="font-size: 0.88rem;font-weight: 700;color: #000000;">格力广东省分公司</span>
				</div>
				<span style="font-size: 0.75rem;font-weight: bold;color: #000000;">0796-756362</span>
			</div>
			<ul class="flex-1 tab d-flex j-sb a-center position-relative">
				<header class="d-flex j-start a-center" style="height: 1.73rem;align-self: flex-start;padding: 1.44rem;position: absolute;">
					<span style="font-weight: 700; font-size: 0.94rem;">订单数据</span>
				</header>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/daifukuan@2x.png">
					<span class="number">{{homeData.await_pay}}</span>
					<span class="name">待付款</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/daifahuo@2x.png">
					<span class="number">{{homeData.await_ship}}</span>
					<span class="name">待发货</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/daiquhuo@2x.png">
					<span class="number">{{homeData.await_pickup}}</span>
					<span class="name">待取货</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/daishouhuo@2x.png">
					<span class="number">{{homeData.await_receiving}}</span>
					<span class="name">待收货</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/yiquxiao@2x.png">
					<span class="number">{{homeData.order_cancelled}}</span>
					<span class="name">已取消</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/yiwancheng@2x.png">
					<span class="number">{{homeData.finished}}</span>
					<span class="name">已完成</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/daipingjia@2x.png">
					<span class="number">{{homeData.await_comment}}</span>
					<span class="name">待评价</span>
				</li>
				<li class="h-100 d-flex flex-column j-sb a-center">
					<img class="logo" src="@/assets/Home/tuihuanshouhou@2x.png">
					<span class="number">{{homeData.return_number}}</span>
					<span class="name">退/换售后</span>
				</li>
			</ul>
		</header>

		<div class="data">
			<header class="d-flex j-sb a-end" style="height: 1.69rem;">
				<div>
					<span style="font-weight: 700; font-size: 0.94rem;">销售数据</span>
					<time style="font-size: 0.75rem;color: #666666;margin-left: 1rem;">截止{{date}}</time>
				</div>
				<ul class="period d-flex j-sb a-center">
					<li @click="setCurIndex(item.id,index)" :class="curIndex==index?'active':''" v-for="(item,index) in period" :key="index">{{item.name}}</li>
				</ul>
				<!-- <div class="chooseDate d-flex j-center a-center" style="border: 2px solid #1E69FF;border-radius: 4px;height: 100%;font-size: 0.77rem;">
					<input type="date" style="border: none;outline: none;height: 100%;">至<input type="date" style="border: none;outline: none;height: 100%;"><button style="background: #1E69FF;color: #FFFFFF;border: none;height: 100%;outline: none;padding: 0 0.87rem;box-sizing: border-box;">查询</button>
				</div> -->
				<div class="chooseDate d-flex j-center a-center" style="height: 100%; font-size: 0.75rem;position: relative;">
					<el-date-picker ref="input_period" prefix-icon="none" :clearable="false" v-model="input_period" style="padding-right: 0;padding-left: 0; width: 15rem; height: 100%; border: 2px solid #1E69FF; border-radius: 4px 0 0 4px;"
					 type="monthrange" value-format="yyyy-MM" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
					<img @click="$refs.input_period.focus()" src="@/assets/Home/xuanzeriqi@2x.png" style="cursor: pointer; width: 0.85rem;height: 0.85rem;position: absolute;right: 4.15rem;">
					<button @click="searchTime()" style="font-size: 1rem; background: #1E69FF;color: #FFFFFF;border: none;height: 100%;outline: none;padding: 0 0.85rem; border-radius: 0 4px 4px 0;cursor: pointer;">查询</button>
				</div>
			</header>
			<div class="tables d-flex j-sb a-center">
				<div class="wrap flex-1 one">
					<div style="font-size: 0.75rem;" class="today d-flex flex-column j-sb a-center">
						<span>销售金额(元)</span>
						<span style="font-size: 1.69rem;color: #1E69FF;" >￥{{order_money.count_amount}}</span>
						<div class="d-flex j-center a-center">
							<span v-text="order_money.up=='empty'||order_money.up=='falt'?'持平':order_money.up"
							:style="order_money.up=='empty'||order_money.up=='falt'?'color:#FF9D10':checkUp(order_money.up)==-1?'color:#FF4810':'color:#1AC022'"></span>
							<img v-if="order_money.up!='empty'&&order_money.up!='falt'" 
							:src="checkUp(order_money.up)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
					<div class="table" ref="one"></div>
				</div>
				<div class="wrap flex-1 two">
					<div style="font-size: 0.75rem;" class="today d-flex flex-column j-sb a-center">
						<span> 访客数(人次)</span>
						<span style="font-size: 1.69rem;color: #1E69FF;" >{{visit_num.count_visit_num}}</span>
						<div class="d-flex j-center a-center">
							<span v-text="visit_num.up=='empty'||visit_num.up=='falt'?'持平':visit_num.up"
							:style="visit_num.up=='empty'||visit_num.up=='falt'?'color:#FF4810':checkUp(visit_num.up)==-1?'color:#FF4810':'color:#1AC022'"></span>
							<img v-if="visit_num.up!='empty'&&visit_num.up!='falt'" 
							:src="checkUp(visit_num.up)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
					<div class="table" ref="two"></div>
				</div>
				<div class="wrap flex-1 three">
					<div style="font-size: 0.75rem;" class="today d-flex flex-column j-sb a-center">
						<span>订单支付量(件)</span>
						<span style="font-size: 1.69rem;color: #1E69FF;">{{order_num.count_order_num}}</span>
						<div class="d-flex j-center a-center">
							<span v-text="order_num.up=='empty'||order_num.up=='falt'?'持平':order_num.up"
							:style="order_num.up=='empty'||order_num.up=='falt'?'color:#FF4810':checkUp(order_num.up)==-1?'color:#FF4810':'color:#1AC022'"></span>
							<img v-if="order_num.up!='empty'&&order_num.up!='falt'"
							 :src="checkUp(order_num.up)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
					<div class="table" ref="three"></div>
				</div>
			</div>
			<div class="rank d-flex j-sb a-center">
				<div class="one box d-flex j-sb a-center">
					<div class="left d-flex flex-column j-sb a-start">
						<span style="font-size: 0.87rem;font-weight: 700;color: #666666;">流量贡献No.1</span>
						<span v-if="visit_num.visit_first_store" style="font-size: 0.77rem;font-weight: 700;color: #1E69FF;">
							{{visit_num.visit_first_store.agent_name}}
						</span>
					</div>
					<div class="right">
						<img src="@/assets/Home/liulianggognxian@2x.png" style="width: 2.88rem;height: 2.88rem;">
					</div>
				</div>
				<div class="two box d-flex j-sb a-center">
					<div class="left d-flex flex-column j-sb a-start">
						<span style="font-size: 0.87rem;font-weight: 700;color: #666666;">单店销售额No.1</span>
						<span v-if="order_money.sales_amount_first_store" style="font-size: 0.77rem;font-weight: 700;color: #1E69FF;">
							{{order_money.sales_amount_first_store.agent_name}}
						</span>
					</div>
					<div class="right">
						<img src="@/assets/Home/dandianxiaoshou@2x.png" style="width: 2.82rem;height: 2.82rem;">
					</div>
				</div>
				<div class="three box d-flex j-sb a-center">
					<div class="left d-flex flex-column j-sb a-start">
						<span style="font-size: 0.87rem;font-weight: 700;color: #666666;">单品销售额No.1</span>
						<span v-if="order_money.sale_num_first_goods" style="font-size: 0.77rem;font-weight: 700;color: #1E69FF;">
							{{order_money.sale_num_first_goods.goods_name}}
						</span>
					</div>
					<div class="right">
						<img src="@/assets/Home/danpinxiaoliang@2x.png" style="width: 2.82rem;height: 2.82rem;">
					</div>
				</div>
				<div class="four box d-flex j-sb a-center">
					<div class="left d-flex flex-column j-sb a-start">
						<span style="font-size: 0.85rem;font-weight: 700;color: #666666;">单店客单量No.1</span>
						<span v-if="order_num.order_num_first_store" style="font-size: 0.75rem;font-weight: 700;color: #1E69FF;">
							{{order_num.order_num_first_store.agent_name}}
						</span>
					</div>
					<div class="right">
						<img src="@/assets/Home/dandiankedanliang@2x.png" style="width: 2.82rem;height: 2.82rem;">
					</div>
				</div>
			</div>
		</div>
		<el-carousel indicator-position="none" :interval="5000" :loop="false" height="16.43rem" style="margin-top: 1.55rem;">
			<el-carousel-item>
				<div class="rankDetail d-flex j-sb a-center">
					<div class="box">
						<header class="d-flex j-sb a-end" style="margin-bottom: 1.41rem;">
							<span style="font-size: 0.94rem;font-weight: 700;">品类销售排行</span>
							<router-link style="color: #BBBBBB;font-size: 0.58rem;" to="/table/sale_rank" v-slot="{ href, route, navigate, isActive, isExactActive }"
							 custom>
								<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
									<span>查看全部</span>
									<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
								</a>
							</router-link>
						</header>
						<div class="d-flex" style="font-size: 12px;font-weight: 600;width: 100%;">
							<div style="width: 25%;padding: 10px 0;">排名</div>
							<div style="width: 35%;padding: 10px 0;text-align: center;">商品信息</div>
							<div style="width: 20%;padding: 10px 0;text-align: center;">销量(件)</div>
							<div style="width: 20%;padding: 10px 0;text-align: right;">成交金额(元)</div>
						</div>
						<div v-for="(item,index) in rank1" :key="index" class="d-flex" 
						style="font-size: 12px;width: 100%;">
							<div style="width: 25%;padding: 10px 0;display: flex;align-items: center;">
								<img :src="index==0?require('@/assets/Home/diyi@2x.png'):index==1?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
								 style="width: 1.41rem;height: 1.41rem;">
							</div>
							<div style="width: 35%;padding: 10px 0;">
								<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
									<img :src="item.goods_thumb" style="width: 1.88rem;height: 1.88rem;">
									<span style="margin-left: 0.56rem;text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.goods_name}}</span>
								</div>
							</div>
							<div style="width: 20%;padding: 10px 0;display: flex;align-items: center;justify-content: center;">{{item.sale_number}}</div>
							<div style="width: 20%;padding: 10px 0;display: flex;align-items: center;justify-content: flex-end;">{{item.count_price}}</div>
						</div>
						
					</div>
					<div class="box">
						<header class="d-flex j-sb a-end" style="margin-bottom: 1.44rem;">
							<span style="font-size: 0.87rem;font-weight: 700;">门店客单量排行</span>
							<router-link style="color: #BBBBBB;font-size: 0.58rem;" to="/table/data_rank" v-slot="{ href, route, navigate, isActive, isExactActive }"
							 custom>
								<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
									<span>查看全部</span>
									<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
								</a>
							</router-link>
						</header>
						<div class="d-flex" style="font-size: 12px;font-weight: 600;width: 100%;">
							<div style="width: 25%;padding: 10px 0;">排名</div>
							<div style="width: 45%;padding: 10px 0;text-align: center;">商品信息</div>
							<div style="width: 30%;padding: 10px 0;text-align: right;">销量(件)</div>
						</div>
						<div v-for="(item,index) in rank2" :key="index" class="d-flex" 
						style="font-size: 12px;width: 100%;">
							<div style="width: 25%;padding: 10px 0;display: flex;align-items: center;">
								<img :src="index==0?require('@/assets/Home/diyi@2x.png'):index==1?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
								 style="width: 1.41rem;height: 1.41rem;">
							</div>
							<div style="width: 45%;padding: 10px 0;">
								<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
									<img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;">
									<span style="margin-left: 0.56rem;text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
								</div>
							</div>
							<div style="width: 30%;padding: 10px 0;display: flex;align-items: center;justify-content: flex-end;">{{item.order_num}}</div>
						</div>
					</div>
				</div>
			</el-carousel-item>
			<el-carousel-item>
				<div class="rankDetail d-flex j-sb a-center">
					<div class="box">
						<header class="d-flex j-sb a-end" style="margin-bottom: 1.41rem;">
							<span style="font-size: 0.94rem;font-weight: 700;">门店流量排行</span>
							<router-link style="color: #BBBBBB;font-size: 0.58rem;" to="/table/shop_rank" v-slot="{ href, route, navigate, isActive, isExactActive }"
							 custom>
								<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
									<span>查看全部</span>
									<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
								</a>
							</router-link>
						</header>
						<div class="d-flex" style="font-size: 12px;font-weight: 600;width: 100%;">
							<div style="width: 25%;padding: 10px 0;">排名</div>
							<div style="width: 45%;padding: 10px 0;text-align: center;">商品信息</div>
							<div style="width: 30%;padding: 10px 0;text-align: right;">客流量(件)</div>
						</div>
						<div v-for="(item,index) in rank3" :key="index" class="d-flex" 
						style="font-size: 12px;width: 100%;">
							<div style="width: 25%;padding: 10px 0;display: flex;align-items: center;">
								<img :src="index==0?require('@/assets/Home/diyi@2x.png'):index==1?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
								 style="width: 1.41rem;height: 1.41rem;">
							</div>
							<div style="width: 45%;padding: 10px 0;">
								<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
									<img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;">
									<span style="margin-left: 0.56rem;text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
								</div>
							</div>
							<div style="width: 30%;padding: 10px 0;display: flex;align-items: center;justify-content: flex-end;">{{item.visit_num}}</div>
						</div>
					</div>
					<div class="box">
						<header class="d-flex j-sb a-end" style="margin-bottom: 1.44rem;">
							<span style="font-size: 0.87rem;font-weight: 700;">门店销售额排行</span>
							<router-link style="color: #BBBBBB;font-size: 0.58rem;" to="/table/money_rank" v-slot="{ href, route, navigate, isActive, isExactActive }"
							 custom>
								<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
									<span>查看全部</span>
									<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
								</a>
							</router-link>
						</header>
						<div class="d-flex" style="font-size: 12px;font-weight: 600;width: 100%;">
							<div style="width: 25%;padding: 10px 0;">排名</div>
							<div style="width: 45%;padding: 10px 0;text-align: center;">商品信息</div>
							<div style="width: 30%;padding: 10px 0;text-align: right;">销售额(元)</div>
						</div>
						<div v-for="(item,index) in rank4" :key="index" class="d-flex" 
						style="font-size: 12px;width: 100%;">
							<div style="width: 25%;padding: 10px 0;display: flex;align-items: center;">
								<img :src="index==0?require('@/assets/Home/diyi@2x.png'):index==1?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
								 style="width: 1.41rem;height: 1.41rem;">
							</div>
							<div style="width: 45%;padding: 10px 0;">
								<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
									<img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;">
									<span style="margin-left: 0.56rem;text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
								</div>
							</div>
							<div style="width: 30%;padding: 10px 0;display: flex;align-items: center;justify-content: flex-end;">
							{{item.sales_volume}}</div>
						</div>
						<!-- <table>
							<tr>
								<th>排名</th>
								<th>门店信息</th>
								<th>成交量(件)</th>
							</tr>
							<tr style="font-size: 0.67rem;" v-for="(item,index) in rank4" :key="index">
								<td><img :src="index==0?require('@/assets/Home/diyi@2x.png'):index==1?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
									 style="width: 1.41rem;height: 1.41rem;"></td>
								<td>
									<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
										<img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;">
										<span style="margin-left: 0.56rem; text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
									</div>
								</td>
								<td>{{item.order_num}}</td>
							</tr>
						</table> -->
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
		<router-view />
	</div>
</template>

<script>
	import * as echarts from 'echarts/core';
	import {
		GridComponent,
		DataZoomComponent,
		TooltipComponent
	} from 'echarts/components';
	import {
		LineChart
	} from 'echarts/charts';
	import {
		CanvasRenderer
	} from 'echarts/renderers';

	echarts.use(
		[GridComponent, LineChart, CanvasRenderer, DataZoomComponent, TooltipComponent]
	);
	export default {
		data() {
			return {
				input_period: [],
				curIndex: 2,
				period: [{name:'今天',id:0},{name:'昨天',id:1},{name:'近30天',id:2},{name:'近3个月',id:3}, {name:'近6个月',id:4}],
				rank1: [],
				rank2: [],
				rank3: [],
				rank4: [],
				option1: {
					grid: {
						left: '25',
						right: '25',
						bottom: '20',
						top: '10'
					},
					xAxis: {
						boundaryGap: false,
						data: '',
						axisPointer: {
							lineStyle: {
								color: ['#1E69FF']
							}
						},
						axisLabel:{
							textStyle: {
								color: '#999',
								fontSize: 12,
							}
						},
						axisLine:{
							show:false
						},
						axisTick:{
							show:false
						},
						// max:30
					},
					dataZoom: [//滑动条
						{
							show: true,//是否显示滑动条
							type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
							startValue: 0, // 从头开始。
							endValue: 6,// 一次性展示6个。
							start: 80,
							end: 100,
						}
					],
					yAxis: {
						type: 'value',
						show:false
					},
					tooltip: {
						trigger: 'axis'
					},
					series: {
						data: '',
						type: 'line',
						itemStyle: {
							// 点的颜色。
							color: '#1E69FF'
						},
						symbol: 'none',
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(214, 228, 255)'
							}, {
								offset: 1,
								color: 'rgb(255, 255, 255)'
							}])
						},
				
					}
					
				},
				option2: {
					grid: {
						left: '25',
						right: '25',
						bottom: '20',
						top: '10'
					},
					xAxis: {
						boundaryGap: false,
						data: '',
						axisPointer: {
							lineStyle: {
								color: ['#1E69FF']
							}
						},
						axisLabel:{
							textStyle: {
								color: '#999',
								fontSize: 12,
							}
						},
						axisLine:{
							show:false
						},
						axisTick:{
							show:false
						},
					},
					dataZoom: [//滑动条
						{
							show: true,//是否显示滑动条
							type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
							startValue: 0, // 从头开始。
							endValue: 6,// 一次性展示6个。
							start: 80,
							end: 100,
						}
					],
					yAxis: {
						type: 'value',
						show:false
					},
					tooltip: {
						trigger: 'axis'
					},
					series: {
						data: '',
						type: 'line',
						symbol: 'none',
						itemStyle: {
							// 点的颜色。
							color: '#1E69FF'
						},
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(214, 228, 255)'
							}, {
								offset: 1,
								color: 'rgb(255, 255, 255)'
							}])
						},
						// 高亮样式。
						emphasis: {
							itemStyle: {
								// 高亮时点的颜色。
								color: '#1E69FF'
							}
						}
					}
				},
				option3: {
					grid: {
						left: '25',
						right: '25',
						bottom: '20',
						top: '10'
					},
					xAxis: {
						boundaryGap: false,
						data: '',
						axisPointer: {
							lineStyle: {
								color: ['#1E69FF']
							}
						},
						axisLabel:{
							textStyle: {
								color: '#999',
								fontSize: 12,
							}
						},
						axisLine:{
							show:false
						},
						axisTick:{
							show:false
						},
					},
					dataZoom: [//滑动条
						{
							show: true,//是否显示滑动条
							type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
							startValue: 0, // 从头开始。
							endValue: 6,// 一次性展示6个。
							start: 80,
							end: 100,
						}
					],
					yAxis: {
						type: 'value',
						show:false
					},
					tooltip: {
						trigger: 'axis'
					},
					series: {
						data: '',
						type: 'line',
						symbol: 'none',
						itemStyle: {
							// 点的颜色。
							color: '#1E69FF'
						},
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(214, 228, 255)'
							}, {
								offset: 1,
								color: 'rgb(255, 255, 255)'
							}])
						},
						// 高亮样式。
						emphasis: {
							itemStyle: {
								// 高亮时点的颜色。
								color: '#1E69FF'
							}
						}
					}
				},
				homeData: '',
				order_money: '',
				visit_num: '',
				order_num: '',
				date: '',
				rank_no1: '',
				status:2
			}
		},
		methods: {
			searchTime(){
				this.status = ""
				this.option1.dataZoom[0].start = 0
				this.option1.dataZoom[0].end = 100
				this.option2.dataZoom[0].start = 0
				this.option2.dataZoom[0].end = 100
				this.option3.dataZoom[0].start = 0
				this.option3.dataZoom[0].end = 100
				this.initTable()
			},
			checkUp(data) {
				let status =  (data+'').indexOf('-')
				return status
			},
			setCurIndex(id,index){
				if(this.curIndex == index)return;
				this.status = id
				this.curIndex = index
				this.input_period = ''
				if(index == 0||index == 1||index == 2){
					this.option1.dataZoom[0].start = 80
					this.option1.dataZoom[0].end = 100
					this.option2.dataZoom[0].start = 80
					this.option2.dataZoom[0].end = 100
					this.option3.dataZoom[0].start = 80
					this.option3.dataZoom[0].end = 100
				}else{
					this.option1.dataZoom[0].start = 0
					this.option1.dataZoom[0].end = 100
					this.option2.dataZoom[0].start = 0
					this.option2.dataZoom[0].end = 100
					this.option3.dataZoom[0].start = 0
					this.option3.dataZoom[0].end = 100
				}
				this.initTable()
			},
			dataX(data) {
				let temp = []
				data.forEach((item) => {
					temp.push(item.day)
				})
				return temp
			},
			dataY(data) {
				let temp = []
				data.forEach((item) => {
					if(item.visit_num != undefined){
						temp.push(item.visit_num)
					}
					if(item.order_num != undefined){
						temp.push(item.order_num)
					}
					if(item.order_amount != undefined){
						temp.push(item.order_amount)
					}
					// temp.push((Math.random().toFixed(1)*100))
				})
				return temp
			},
			initTable() {
				
				let p1 = this.$api.order_money({
					act:'sales_amount',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type:this.status,
					start_month:this.input_period[0]||"",
					end_month:this.input_period[1]||""
				})
				let p2 = this.$api.visit_num({
					act:'visit_num',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type:this.status,
					start_month:this.input_period[0]||"",
					end_month:this.input_period[1]||""
				})
				let p3 = this.$api.order_num({
					act:'order_num',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type:this.status,
					start_month:this.input_period[0]||"",
					end_month:this.input_period[1]||""
				})
				Promise.all([p1, p2, p3]).then((res) => {
					this.order_money = res[0]
					this.visit_num = res[1]
					this.order_num = res[2]
					this.option1.xAxis.data = this.dataX(this.order_money.data)
					this.option1.series.data = this.dataY(this.order_money.data)
					this.option2.xAxis.data = this.dataX(this.visit_num.data)
					this.option2.series.data = this.dataY(this.visit_num.data)
					this.option3.xAxis.data = this.dataX(this.order_num.data)
					this.option3.series.data = this.dataY(this.order_num.data)
					let myChart1 = echarts.init(this.$refs.one);
					let myChart2 = echarts.init(this.$refs.two);
					let myChart3 = echarts.init(this.$refs.three);
					this.option1 && myChart1.setOption(this.option1);
					this.option2 && myChart2.setOption(this.option2);
					this.option3 && myChart3.setOption(this.option3);
					setTimeout(function() {
						window.onresize = function() {
							myChart1.resize();
							myChart2.resize();
							myChart3.resize();
						}
					}, 200)
				})
			},
			getHomeData() {
				let param = {
					act: 'order_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.homeData(param).then((res) => {
					this.homeData = res.data
				})
			},
			getDate() {
				let d = new Date()
				this.date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
			},
			getRank() {
				let param = {
					act: 'goods_sale_ranking_list',
					sort: 'desc',
					sort_field:'count_price',
					page: 1,
					size: 3,
					type: -1,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.sale_rank(param).then((res) => {
					if(res.code == 0){
						this.rank1 = res.data
					}
				})
			},
			order_num_ranking(){
				let param = {
					act: 'order_num_ranking',
					page: 1,
					size: 3,
					type: -1,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.order_num_ranking(param).then((res) => {
					if(res.code == 0){
						this.rank2 = res.data
					}
				})
			},
			visit_ranking(){
				let param = {
					act: 'visit_ranking',
					page: 1,
					size: 3,
					type: -1,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.order_num_ranking(param).then((res) => {
					if(res.code == 0){
						this.rank3 = res.data
					}
				})
			},
			sales_volume_ranking(){
				let param = {
					act: 'sales_volume_ranking',
					page: 1,
					size: 3,
					type: -1,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.sales_volume_ranking(param).then((res) => {
					if(res.code == 0){
						this.rank4 = res.data
					}
				})
			}
		},
		mounted() {
			this.initTable()
			this.getHomeData()
			this.getDate()
			this.getRank()
			this.order_num_ranking()
			this.visit_ranking()
			this.sales_volume_ranking()
		}
	}
</script>
<style>
	.el-input__icon {
		display: none;
	}

	.el-range__close-icon {
		display: none !important;
	}

	.el-range-separator {
		line-height: 1rem !important;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 0.75rem;
	}
</style>
<style scoped lang="less">
	.order_index {
		max-width: 73.24rem;
		margin: 0 auto;

		header {
			margin-bottom: 0.94rem;

			.info {
				width: 14.06rem;
				height: 12.63rem;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 6px;

				.icon {
					width: 5.63rem;
					height: 5.63rem;
					border-radius: 50%;
					border: 4px solid #FFFFFF;
					box-sizing: border-box;
					box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.58) inset;
					background: url(../../assets/distributors/logo@2x.png);
					background-size: 100% 100%;
					background-repeat: no-repeat;
				}
			}

			.tab {
				height: 12.63rem;
				background: #FFFFFF;
				border-radius: 6px;
				margin-left: 0.94rem;

				li {
					list-style: none;
					flex: 1;
					padding: 4rem 0 1.44rem 0;
					box-sizing: border-box;
					cursor: pointer;

					.logo {
						width: 1.6rem;
						height: 1.6rem;
					}

					.number {
						font-size: 1.31rem;
						font-weight: 700;
					}

					.name {
						font-size: 0.94rem;
						color: #666666;
						font-weight: bold;
					}

					&:hover {
						background: #E7EFFF;
					}
				}
			}
		}


		.data {
			height: 26rem;
			background: #FFFFFF;
			margin-top: 1.41rem;
			border-radius: 6px;
			padding: 1.41rem;
			box-sizing: border-box;

			.period {
				list-style: none;
				width: 30rem;
				height: 100%;

				cursor: pointer;
				font-size: 0.77rem;
				color: #666666;

				li {
					flex: 1;
					height: 100%;
					line-height: 1.73rem;
					border-radius: 4px;
					text-align: center;

					&:hover {
						background: #1A6BFF;
						color: #FFFFFF;
					}

				}

				.active {
					background: #1A6BFF;
					color: #FFFFFF;
				}
			}

			.tables {
				height: 16rem;

				.table {
					height: 8rem;
				}
			}

			.rank {
				height: 5.63rem;

				.box {
					background: rgba(231, 239, 255, .5);
					cursor: pointer;
					height: 100%;
					flex: 1;
					border-radius: 6px;
					padding: 0 1.15rem;

					&:not(:last-child) {
						margin-right: 20px;
					}

					&:hover {
						background: rgba(231, 239, 255, 1);
					}

					.left {
						height: 100%;
						padding: 1.5rem 0;
						box-sizing: border-box;

						span {
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							-webkit-box-orient: vertical;
						}
					}
				}
			}
		}

		.rankDetail {
			height: 100%;
			box-sizing: border-box;

			.box {
				box-sizing: border-box;
				flex: 1;
				height: 100%;
				background: #FFFFFF;
				border-radius: 6px;
				padding: 1.41rem;
				box-sizing: border-box;

				&:first-of-type {
					margin-right: 1.41rem;
				}
			}

			table {
				text-align: center;
				width: 100%;
				height: calc(100% - 1.41rem);

				th {
					font-size: 0.77rem;
				}

				tr {

					td {
						margin: 0 2rem;
					}
				}
			}
		}
	}
</style>
